import React, { useEffect, useState } from "react";
import classes from "./Drawer.module.css";
import { motion, useAnimationControls } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { toggleDrawer } from "../Slices/drawerSlice";
import { useNavigate } from "react-router-dom";

const Drawer = () => {
  const variants = {
    hidden: {
      y: -window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const controls = useAnimationControls();

  const { drawer } = useAppSelector((state) => state.drawerSlice);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (drawer) {
      controls.start("visible");
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [drawer]);

  const closeDrawer = () => {
    controls.start("hidden");
    dispatch(toggleDrawer());
  };

  const [menuItems, setMenuItems] = useState<
    { id: number; name: string; link: string; img: string }[]
  >([
    {
      id: 1,
      name: "Movies",
      link: "/movies",
      img: "/assets/navbar-icons/popcorn-active.png",
    },
    {
      id: 2,
      name: "Series",
      link: "/series",
      img: "/assets/navbar-icons/television-active.png",
    },
    {
      id: 3,
      name: "Shortz",
      link: "/shortz",
      img: "/assets/navbar-icons/clapper-active.png",
    },
    {
      id: 4,
      name: "Community",
      link: "/community",
      img: "/assets/navbar-icons/community-active.png",
    },
  ]);

  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    closeDrawer();
    navigate(path);
  };

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        ease: "anticipate",
      }}
    >
      <div className={classes.container}>
        <div className={classes.navbar}>
          <img
            src="/assets/images/logo2.png"
            alt="logo"
            className={classes.logo}
          />
          <button
            type="button"
            className={classes.close_icon_container}
            onClick={() => closeDrawer()}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>

        <div className={classes.menu_container}>
          {menuItems.map((dataItem, idx) => {
            return (
              <button
                className={classes.menu_item}
                key={idx}
                onClick={() => handleNavigate(dataItem?.link)}
              >
                <img
                  src={dataItem.img}
                  alt={dataItem.name}
                  className={classes.item_img}
                />
                <p className={classes.item}>{dataItem.name}</p>
              </button>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default Drawer;
